module.exports = __webpack_public_path__ + "static/img/Home3.4d6d634.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Home3.png
// module id = SkJQ
// module chunks = 1